import React, { useState } from "react";
import NotificationBar from '../components/NotificationBar'

const AlertContext = React.createContext(
    {
    //     notification: null,
    //     notificationText: null,
        success: () => {},
        error: () => {}
    }
)

const STATES = {
    SUCCESS: 'success',
    ERROR: 'danger',
}

function AlertProvider({children}) {
    const [notification, setNotification] = useState(null);
    const [notificationText, setNotificationText] = useState(null);

    const success = (text) => {
        window.scroll(0, 0);
        setNotificationText(text);
        setNotification(STATES.SUCCESS);
    }
    
    const error = (text) => {
        window.scroll(0, 0);
        setNotificationText(text);
        setNotification(STATES.ERROR);
    }

    return <AlertContext.Provider value={{ success, error, notification, notificationText }}>
        <NotificationBar />
        {children}
    </AlertContext.Provider>
}

export { AlertProvider, AlertContext }